<template>
  <div id="inspire">
    <v-toolbar
      app
      flat
      class="toolbar-user"
      color="white"
      height="70px"
    >
      <span class="page-name">{{ name }}</span>
      <v-spacer></v-spacer>
      <template v-if="$vuetify.breakpoint.mdAndDown && links && links.length">
        <v-menu
          transition="slide-y-transition">
          <v-btn
            slot="activator"
            class="toolbar-btn-menu"
          >
            <v-icon left>menu</v-icon>
            Actions
          </v-btn>
          <v-card>
            <v-list dense>
              <v-list-tile
                v-for="button in links"
                :key="button.title"
                @click="go(button.url)"
              >
                <img
                  class="icon-img-toolbar v-icon v-icon--left material-icons"
                  :class="{
                      'theme--dark': button.blue,
                      'theme--light': !button.blue
                      }"
                  :src="require('@/assets/' + button.blue_icon)"/>
                <span class="ml-3"> {{ button.title }} </span>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
      </template>
      <template v-else>
        <v-btn
          v-for="button in links"
          :key="button.title"
          :index="button.title"
          flat
          @click="go(button.url)"
          :ref="button.blue ? 'addOrder' : ''"
          class="toolbar-text"
          :class="{
            'button-blue-hotel4box white--text-hotel4box':button.blue,
            'button-white-hotel4box blue--text-hotel4box': !button.blue
              }"
        >
          <img
            class="icon-img-toolbar v-icon v-icon--left material-icons"
            :class="{
                  'theme--dark': button.blue,
                  'theme--light': !button.blue
                  }"
            :src="require('@/assets/' + (button.icon || button.blue_icon))"/>
          {{ button.title }}
        </v-btn>
      </template>
    </v-toolbar>
    <v-layout align-center row justify-center fill-height v-model="dialog">
      <v-dialog v-model="dialog" persistent max-width="350">
        <v-card flat class="dialog-modal">
          <v-card-title class="headline headline-modal">Please tell us how shipment is coming to us:</v-card-title>
          <v-card-text class="v-card__text-modal-order">
            <v-radio-group v-model="orderType">
              <v-radio
                label="Online order or my shipment arriving by carrier"
                :value="$orderType.online"
                class="radio-order"
              ></v-radio>

              <v-radio
                  label="My Shipment (need label)"
                  :value="$orderType.myShipmentLabel"
                  class="radio-order"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-actions>
            <v-btn color="red darken-1" flat @click="cancelClick" class="text-button">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#008EFF" flat @click="afterModal" class="text-button">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: "Toolbar",
    props: ['name', 'links'],
    data() {
      return {
        dialog: false,
        orderType: this.$orderType.online
      }
    },
    created() {
      this.$store.watch(
        (state) => {
          this.dialog = state.orders.click
        },
      );
    },
    methods: {
      cancelClick() {
        this.dialog = !this.dialog
        this.$store.dispatch('setClick', this.dialog)
      },
      afterModal() {
        this.$store.commit('setLoading', true)
        this.$store.dispatch('setTypeOrder', this.orderType)
        this.$store.dispatch('clearSecondStep')
        this.$store.dispatch('setDataFirstStepClear')
        this.$store.dispatch('setItemsFirstStepClear')
        this.$store.dispatch('setPdfClear')
        this.$store.dispatch('setPdfFileClear')

        this.go(this.$checkRoute.addOrder)
        this.$store.commit('setLoading', true)
      },
      go(url) {
        if (url === this.$checkRoute.addOrder) {
          this.dialog = !this.dialog
          url = url + "/1/" + this.orderType
        }
        if (!this.dialog && this.$route.path !== url) {
          this.$store.dispatch('setClick', this.dialog)
          this.$router.push(url)
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .toolbar-text
    text-transform none !important

  .v-cart-title-padding
    padding 0

  .page-name
    height 28px
    min-width 112px
    color #252A30
    font-family Roboto
    font-size 24px
    font-weight bold
    line-height 28px

  .icon-img-toolbar
    height 14px
    width 14px

  .button-blue-hotel4box
    height 38px
    width 164px
    border-radius 6px
    background-color #008EFF !important

  .white--text-hotel4box
    color #FFFFFF
    font-family Roboto
    font-size 14px
    font-weight 500
    line-height 16px

  .button-white-hotel4box
    height 38px
    width 164px
    border 1px solid #008EFF
    border-radius 6px
    background-color #ffffff !important

  .blue--text-hotel4box
    color #008EFF
    font-family Roboto
    font-size 14px
    font-weight 500
    line-height 16px

  .text-button
    text-transform none
    border-radius .35em

  .headline-modal
    color #008EFF
    font-size 21px !important

  .radio-order
    margin-bottom 1.5em

  .radio-order:last-child
    margin-bottom 0

  .v-card__text-modal-order
    padding-top 0

  .dialog-modal
    border-radius .5em

  .toolbar-btn-menu
    background-color #008EFF !important
    border-radius 6px
    color white
</style>
